import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { UserManagementService } from 'src/app/services/user-management.service';
import { isNullOrUndefined } from 'util';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Iuser, User } from '../interfaces/user';
import { ToastrService } from 'ngx-toastr';
import { EncdecService } from 'src/app/services/encdec.service';
import { ConstantsModule } from 'src/app/common/constants/constants.module';
import { AuthloginService } from 'src/app/services/login/authlogin.service';

@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.css']
})
export class EditUserComponent implements OnInit {
  @Input() user; 
  data;
  status: boolean;
  emailinvalid: boolean ;
  contactvalid: boolean;
  empty:boolean;
  constructor(
    private userService:UserManagementService,
    private fb:FormBuilder,
    private modal: NgbActiveModal,
    private toastrService: ToastrService,
    private encdecservice : EncdecService,
    private constant : ConstantsModule,
    private toastr : ToastrService,
    private authservice : AuthloginService
  ){} 

  ngOnInit() {
    this.data=this.user;    
  }

  isEmpty(name){
    if (name){
      this.empty=false;
    }
    else{
      this.empty=true;
    }
    return this.empty;
  }


  keyPress(event: any,contact) {
    const pattern = /[0-9\+\-\ ]/;

    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar) && contact.length != 10) {
      event.preventDefault();
    }
  }
  // focusEvent(e, value) {
  //   if ((value === null || value === undefined || value === '')) {
  //     this.status= true;
  //     console.log('this.status',this.status);
  //   } else {
  //     this.status= false;
  //   }
  // }
  validateContact(contact){
    console.log(contact,contact.length);
    let mobile = contact;
   console.log(mobile);
   
    if(contact.length<=9){
      this.status=true;
       this.toastr.error("number must be 10 characters");
    }else {
      this.status=false;
      this.toastr.success("Contact no. is 10 digits")
    }
    console.log("status",this.status);
    
  
  }

  
  validateEmail(email) {
    let reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    //var address = document.getElementById[email].value;
    if (reg.test(email) == false) {
      this.toastr.error("Please Enter Valid Email");
      this.emailinvalid = true;
      console.log('emailinvalid',this.emailinvalid);
      return false;
    } else {
      this.emailinvalid = false;
      return true;
    }
  }
  submit(){
    console.log("dataaa",this.data);
    
      let postdata = {
        ... this.data,
      //  "UserId" : this.data['userId'],
        "username" : this.data['userName'] ? this.encdecservice.rsaenc(this.constant.PUBLIC_KEY,this.data['userName']): this.data['userName'],
        "mobileNo" :this.data['mobileNo']? this.encdecservice.rsaenc(this.constant.PUBLIC_KEY,this.data['mobileNo']): this.data['mobileNo'],
        "email" : this.data['email']? this.encdecservice.rsaenc(this.constant.PUBLIC_KEY,this.data['email']): this.data['email'],
        "firstName" : this.data['firstName'],
        "lastName" : this.data['lastName'],
        // "permissions": "",
        // "userDetailsJson" :"" ,
        // "approver": "",
        // "passwordHash":"" ,
        // "createdTs": "",
        // "updatedTs": "",
        // "deleted": "",
        // "token": "null",
        "status": 1,
        userDetailsJson: {
          stateName: this.data.userDetailsJson.stateName,
          stateId: this.data.userDetailsJson.stateId,
          countryId: this.data.userDetailsJson.countryId,
          countryName: this.data.userDetailsJson.countryName,
          locationType: this.data.userDetailsJson.locationType,
          locationName:this.data.userDetailsJson.locationName,
          locationId: this.data.userDetailsJson.locationId,
          permissions: {
            25: {
              PERMITTED: [
                {
                  entityType: this.data.locationType ?  (this.data.locationType).toString().toUpperCase() : null,
                  entityList: [
                    this.data.userDetailsJson.locationId
                  ]
                }
              ]
            }
          }
        },
        roles: [this.data['role']],
        userInfoEncrypted : true
      }
      if (this.data) {
          postdata['userId'] = this.data.userId;
          console.log('postdat--',postdata);
        this.userService.updateUser(postdata).subscribe((res: any) => {
          console.log('res',res);
          
          if (res.result.success) {
            console.log('success');
            // Swal.fire('Success...', res.result.content, 'success');
            this.toastr.success(res.result.content);
            this.modal.close();
          } else {
            // console.log('res',res.result);
            if(res.result.status != 406 || res.result.status != 420){
              this.toastr.error(res.result.content);
            // Swal.fire('Failure...', res.result.content, 'error');
            } if(res.result.status == 420){
              this.authservice.logoutuserandsessionclear();
            }
          }
        }, (err) => {
          console.log('error');
          // Swal.fire('Failure...', err.message, 'error');
        })
        return;
      }
  }
  closeModal() {
    this.modal.dismiss();
  }


}


